import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Badge,
  Modal,
  Form,
  Spinner,
} from "react-bootstrap";
import AppSpinner from "../AppSpinner/AppSpinner";
import apiUrl from "../../utils/apiUrl";
import formatMoney from "../../utils/formatMoney";
import { connect } from "react-redux";
import moment from "moment";
import { saveAs } from "file-saver";

const select = (state) => {
  return {
    token: state.auth.token,
  };
};

class ConnectedFoundationSubscriptionsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      requestedPayments: [],
      receivedPayments: [],
      foundationSubscriptions: [],
      creatingSubscription: false,
      showCreateSubscriptionModal: false,
      foundationName: "",
      planId: "BASICO2022",
      amountPayed: 0,
      amountToFix: 0,
      paymentFrequency: 1,
      recurringPaymentDay: 20,
      formValidated: false,
      errorMessage: "",
    };
    this.handleCreateSubscription = this.handleCreateSubscription.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
  }

  async componentDidMount() {
    const { token } = this.props;
    const fetchFoundationSubscriptions = fetch(
      `${apiUrl}/admin/foundations-suscriptions?token=${token}`
    );

    const respFoundationSubscriptions = await fetchFoundationSubscriptions;

    const dataFoundationSubscriptions =
      await respFoundationSubscriptions.json();

    if (dataFoundationSubscriptions.success) {
      this.setState({
        foundationSubscriptions:
          dataFoundationSubscriptions.foundationSubscriptions,
      });
    }

    this.setState({ isLoading: false });
  }

  async handleCreateSubscription(event) {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;

    this.setState({ formValidated: true });

    if (form.checkValidity()) {
      const { token } = this.props;
      const {
        foundationName,
        planId,
        amountPayed,
        amountToFix,
        paymentFrequency,
        recurringPaymentDay,
      } = this.state;
      this.setState({ creatingSubscription: true });
      const createSubProm = await fetch(
        `${apiUrl}/admin/foundation_subscription/create?token=${token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            foundationName,
            planId,
            amountPayed,
            amountToFix,
            paymentFrequency,
            recurringPaymentDay,
          }),
        }
      );
      const createSubRes = await createSubProm.json();
      if (createSubRes.success) {
        this.setState({ errorMessage: "Suscripción agregada con éxito" });
      } else {
        this.setState({ errorMessage: createSubRes.message });
      }
      this.setState({ creatingSubscription: false });
    }
  }

  async downloadFile() {
    fetch(`${apiUrl}/export/subscription_payments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => resp.json())
      .then((json) => {
        if (json && json.success) {
          const byteCharacters = window.atob(json.data);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          saveAs(blob, "Suscripciones.xlsx");
        } else {
          alert("Error. Inténtalo nuevamente.");
        }
      });
  }

  render() {
    const {
      isLoading,
      foundationSubscriptions,
      creatingSubscription,
      showCreateSubscriptionModal,
      foundationName,
      planId,
      amountPayed,
      amountToFix,
      paymentFrequency,
      recurringPaymentDay,
      formValidated,
      errorMessage,
    } = this.state;
    const { history } = this.props;

    if (isLoading) return <AppSpinner />;

    return (
      <div className="table-info-component foundation-payments-component">
        <Container>
          <Row>
            <Col xs={12}>
              <h2 className="header">Fundaciones</h2>
            </Col>

            <Col xs={12}>
              <Row>
                <Col>
                  <h4 className="title">Suscripciones</h4>
                </Col>
                <Col>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      this.setState({ showCreateSubscriptionModal: true });
                    }}
                  >
                    Agregar suscripción
                  </Button>
                </Col>
                <Col>
                  <Button
                    variant="secondary"
                    onClick={() => this.downloadFile()}
                  >
                    Descargar suscripciones mes actual
                  </Button>
                </Col>
              </Row>

              {!foundationSubscriptions.length ? (
                <p>No hay suscripciones.</p>
              ) : (
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Fundación</th>
                      <th>Frecuencia de pago</th>
                      <th>Valor</th>
                      <th>Fecha de creación</th>
                      <th>Fecha del último pago</th>
                      <th>Método de pago</th>
                      <th>Plan</th>
                      <th>Día de pago</th>
                      <th>Estado nibi</th>
                      <th>Comentario</th>
                      <th>Estado</th>
                      <th>Donantes mensuales activos</th>
                      <th>Donaciones recibidas este mes</th>
                      <th>Disponible a la fecha</th>
                      <th>Meses activos en nibi</th>
                      {/* <th>Donaciones esporádicas</th>
                      <th>Tasa sostenibilidad plan</th>
                      <th>Tasa sostenibilidad plan mes anterior</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {foundationSubscriptions.map((suscription, index) => (
                      <tr key={suscription._id}>
                        <td>{index + 1}</td>
                        <td>{suscription.foundationInfo[0].name}</td>
                        <td>
                          {suscription.paymentFrequency === 1
                            ? "Mensual"
                            : "Anual"}
                        </td>
                        <td>${formatMoney(suscription.amount)}</td>
                        <td>
                          {moment(suscription.dateCreated).format("YYYY-MM-DD")}
                        </td>
                        <td>
                          {moment(suscription.datePayed).format("YYYY-MM-DD")}
                        </td>
                        <td>{suscription.paymentMethod}</td>
                        <td>{suscription.plan.name}</td>
                        <td>{suscription.recurringPaymentDay}</td>
                        <td>
                          {suscription.foundationInfo[0].nibiStatus || "-"}
                        </td>
                        <td>
                          {suscription.foundationInfo[0].nibiComments || "-"}
                        </td>
                        <td>
                          <Badge
                            variant={
                              suscription.status === "ACTIVE"
                                ? "success"
                                : "danger"
                            }
                          >
                            {suscription.status.toLowerCase()}
                          </Badge>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {suscription.recurringDonors}
                        </td>
                        {/* <td style={{textAlign: "center"}}>
                          {suscription.sporadicDonations}
                        </td> */}
                        {/* <td>
                            <Button
                              variant="info"
                              size="sm"
                              onClick={() => {
                                history.push(`/fundaciones/desembolsos/${payment._id}`);
                              }}
                            >
                              Ver más
                            </Button>
                          </td> */}
                        <td style={{ textAlign: "center" }}>
                          $
                          {formatMoney(
                            Math.round(suscription.donationsamountMonth)
                          )}{" "}
                          ({suscription.donationsMonth})
                        </td>
                        <td style={{ textAlign: "center" }}>
                          $
                          {formatMoney(Math.round(suscription.walletAvailable))}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {suscription.activeMonths}
                        </td>
                        {/* <td style={{textAlign: "center"}}>
                          {Math.round(
                            (suscription.lastMonthAvailable /
                              suscription.amount) *
                              10000
                          ) / 100}
                          %
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Col>
          </Row>
          <Modal
            show={showCreateSubscriptionModal}
            onHide={() => {
              this.setState({
                showCreateSubscriptionModal: false,
                errorMessage: "",
              });
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Crear suscripción</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {creatingSubscription ? (
                <div style={{ textAlign: "center" }}>
                  <Spinner size="sm" variant="warning" animation="border" />
                </div>
              ) : errorMessage ? (
                <h4>{errorMessage}</h4>
              ) : (
                <Form
                  noValidate
                  validated={formValidated}
                  onSubmit={this.handleCreateSubscription}
                  style={{ marginTop: "15px" }}
                >
                  <Form.Row>
                    <Form.Group as={Col} lg={6} xs={6}>
                      <Form.Label>Fundación</Form.Label>
                      <Form.Control
                        placeholder="Nombre de la fundación"
                        name="foundationName"
                        value={foundationName}
                        onChange={(e) => {
                          this.setState({ foundationName: e.target.value });
                        }}
                        required
                      />
                    </Form.Group>
                    <Form.Group as={Col} lg={6} xs={6}>
                      <Form.Label className="nibi-label">Plan</Form.Label>
                      <Form.Control
                        as="select"
                        name="planId"
                        value={planId}
                        onChange={(e) => {
                          this.setState({ planId: e.target.value });
                        }}
                        required
                      >
                        <option value="LITE">Lite</option>
                        <option value="BASICO2022">Básico</option>
                        <option value="ADVANCED2022">Avanzado</option>
                        <option value="PRO2022">Profesional</option>
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} lg={6} xs={6}>
                      <Form.Label>Cantidad pagada</Form.Label>
                      <Form.Control
                        type="number"
                        name="amountPayed"
                        value={amountPayed}
                        onChange={(e) => {
                          this.setState({ amountPayed: e.target.value });
                        }}
                        required
                      />
                    </Form.Group>
                    <Form.Group as={Col} lg={6} xs={6}>
                      <Form.Label>Cantidad del próximo corte</Form.Label>
                      <Form.Control
                        type="number"
                        name="amountToFix"
                        value={amountToFix}
                        onChange={(e) => {
                          this.setState({ amountToFix: e.target.value });
                        }}
                        required
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} lg={6} xs={6}>
                      <Form.Label className="nibi-label">
                        Frecuencia de pago
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="paymentFrequency"
                        value={paymentFrequency}
                        onChange={(e) => {
                          this.setState({ paymentFrequency: e.target.value });
                        }}
                        required
                      >
                        <option value={1}>Mensual</option>
                        <option value={12}>Anual</option>
                      </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} xs={6}>
                      <Form.Label>Día de corte</Form.Label>
                      <Form.Control
                        type="number"
                        name="recurringPaymentDay"
                        value={recurringPaymentDay}
                        onChange={(e) => {
                          this.setState({
                            recurringPaymentDay: e.target.value,
                          });
                        }}
                        required
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Button type="submit">Crear</Button>
                  </Form.Row>
                </Form>
              )}
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    );
  }
}

const FoundationSubscriptionsComponent = connect(select)(
  ConnectedFoundationSubscriptionsComponent
);

export default FoundationSubscriptionsComponent;
